module.exports = __webpack_public_path__ + "img/driving.9522ed3.svg";